import { useCallback, useState } from "react";
import { useSaveDownloaded } from "../../../../../lib/hooks/useSaveDownloaded";
import ReportService from "../../../../../services/reportGeneration";

export const useExport = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { save } = useSaveDownloaded(
    "Bobby's Coupons.csv",
    "text/csv;charset=utf-8",
    setIsLoading,
  );

  const onExportClicked = useCallback(async () => {
    try {
      setIsLoading(true);

      const res: any = await ReportService.exportByName("BulkCoupons", null);

      save(res);
    } catch {
      setIsLoading(false);
    }
  }, [save]);

  return { onExportClicked, isLoading };
};
